var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    transform: "translate(-479 -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10683",
    "data-name": "Rectangle 10683",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(479 579)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "web-39",
    d: "M102.565,99.733a17.228,17.228,0,0,0,0-4.8h4.056a9.387,9.387,0,0,1,0,4.8m-6.18,6.672a18.78,18.78,0,0,0,1.656-4.272h3.54a9.636,9.636,0,0,1-5.2,4.272m-.3-6.672H94.525a15.1,15.1,0,0,1,0-4.8h5.616a15.1,15.1,0,0,1,0,4.8m-2.808,7.152a16.276,16.276,0,0,1-2.292-4.752h4.584a16.276,16.276,0,0,1-2.292,4.752m-4.8-14.352h-3.5a9.508,9.508,0,0,1,5.184-4.272,20.683,20.683,0,0,0-1.68,4.272m-3.5,9.6h3.5a20.683,20.683,0,0,0,1.68,4.272,9.61,9.61,0,0,1-5.184-4.272m-.984-2.4a9.387,9.387,0,0,1,0-4.8H92.1a17.228,17.228,0,0,0,0,4.8m5.232-11.964a16.343,16.343,0,0,1,2.292,4.764H95.041a16.342,16.342,0,0,1,2.292-4.764m8.3,4.764H102.1a18.78,18.78,0,0,0-1.656-4.272,9.584,9.584,0,0,1,5.2,4.272m-8.3-7.2a12,12,0,1,0,12,12A12.012,12.012,0,0,0,97.333,85.333Z",
    transform: "translate(401.667 501.667)",
    fill: "#006599",
    stroke: "#efefef",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.4b95d55f.svg";
export { ForwardRef as ReactComponent };